module.exports = __webpack_public_path__ + "media/rise5.2d5de5e0.mp4";